import type { ChartType } from '@/lib/analytics/charts/chart.type';
import Trans from 'next-translate/Trans';

// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const followerGrowthHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.pinterest.follower_growth',
    margin: { left: -20, right: 10 },
    name: {
        date: 'date',
        estimated: 'estimated_data',
        value: 'chart.pinterest.follower_growth_name',
        evolution: 'evolution',
        avg: 'chart.pinterest.follower_growth'
    },
    id: 'follower_growth_history',
    color: {
        value: 'blue',
        avg: 'gray',
        estimated: 'blue',
        unavailable: 'gray'
    },
    legendTypes: {
        value: 'line',
        unavailable: 'square'
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: (
        <Trans
            i18nKey="analytics:chart.pinterest.tooltip_follower_growth"
            components={{ br: <br /> }}
        />
    ),
    size: SIZE_50,
    type: 'chart',
    noDataToken: 'no_data_period',
    element: LineChart
};
